import Vue from "vue";
import Affix from "./affix";

Vue.directive("affix", Affix);
